import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import i18n from "@/locale/i18n";
import { MultiSelectChangeEvent } from "primevue/multiselect";
import { ref, onMounted, watch, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'XAllSelect',
  props: {
    modelValue: {
        type: Array<any>,
        default : [],
        require: true
    },
    optionLabel: {
        type: String,
        default: 'label'
    },
    optionValue: {
        type: null,
        default: 'value'
    },
    options: {
        type: Array<any>,
        require: true
    },
    value: {
        type: Array,
        default: () => {[]}
    },
    enableAllValue: {
        type: Boolean,
        default: false
    },
    enableCustomizePanleStyle: {
        type: Boolean,
        default: false
    }
},
  emits: ['update:modelValue', 'change', 'show', 'hide', 'click'],
  setup(__props, { emit: emits }) {

const props = __props

const t = i18n.global.t;
const isMouseClick = ref(false);


watch(() => props.modelValue, (newVal, oldVal)=> {
    modelValueTem.value = newVal;
    if (!modelValueTem.value) {
        modelValueTem.value = [];
    }
    // if (props.options && modelValueTem.value.length && modelValueTem.value.length === props.options.length) {
    //     multiSelectAllSelected.value = 'YES';
    // } else {
    //     multiSelectAllSelected.value = 'NO';
    // }
    if (oldVal.includes("ALL") === false && newVal.includes("ALL") === true && newVal.length > 1) {
        modelValueTem.value = ["ALL"]
    }
    if (oldVal.includes("ALL") === true && newVal.includes("ALL") === true && newVal.length > 1) {
        modelValueTem.value.shift()
    }
    if (newVal.length == 0) {
        modelValueTem.value = ["ALL"]
    }
    emits('update:modelValue', modelValueTem.value)
}, {deep: true})

watch(() => props.options, (newVal, oldVal)=> {
    optionsProp.value = newVal;
    if (!optionsProp.value) {
        optionsProp.value = [];
    }
    let label = props.optionLabel;
    let value = props.optionValue;
    if (optionsProp.value.length > 0) {
        const all = optionsProp.value.find(item => item[value] == 'ALL');
        if (all) {
            if (modelValueTem.value.length === optionsProp.value.length - 1) {
                modelValueTem.value = ['ALL'];
            }
        }
        if (!all) {
            if (modelValueTem.value.length === optionsProp.value.length) {
                modelValueTem.value = ['ALL'];
            }
            const el = {[label]: '全て', [value]: 'ALL'}
            optionsProp.value.unshift(el);
        }
    }
}, {deep: true})

const updateValue = (newValue: []) => {
    emits('update:modelValue', newValue)
}

const multiSelectRef = ref();

// const multiSelectAllSelected = ref('NO');

const optionsProp = ref(props.options);

const modelValueTem = ref(props.modelValue?props.modelValue:[]);

const displayPanle = ref(false);

const multiSelectIsHide = ref(false);

// const multiSelectBoxChange = (value: any) => {
//     if (value === 'YES') {
//         let arrayTem: String[] = [];
//         props.options!.forEach(item => {
//             arrayTem.push(item[`${optionValueProp.value}`]);
//         });
//         modelValueTem.value = arrayTem;
//         emits('update:modelValue', arrayTem);
//     } else {
//         modelValueTem.value = [];
//         emits('update:modelValue', []);
//     }
// }

// const multiSelectPanleClose = () => {
//     multiSelectAllSelected.value = 'NO';

//     modelValueTem.value = [];
//     emits('update:modelValue', []);
    
//     multiSelectRef.value.hide();

//     console.log("multiSelectRef.value")
//     console.log(multiSelectRef.value)
// }

const multiSelectChange = (event: MultiSelectChangeEvent) => {
    // console.log(props.options)
    // console.log(event.value)
    // if (modelValueTem.value!.length === props.options!.length) {
    //     multiSelectAllSelected.value = 'YES';
    // } else {
    //     multiSelectAllSelected.value = 'NO';
    // }

    modelValueTem.value = event.value;

    emits('update:modelValue', event.value);
    emits('change', event.value);

}

onMounted(() => {
    if (modelValueTem.value === undefined || modelValueTem.value === null) {
        modelValueTem.value = [];
    }
    if (!optionsProp.value) {
        optionsProp.value = [];
    }
    let label = props.optionLabel;
    let value = props.optionValue;
    if (optionsProp.value.length > 0) {
        const all = optionsProp.value.find(item => item[value] == 'ALL' && item[label] == '全て');
        if (all) {
            if (modelValueTem.value.length === optionsProp.value.length - 1) {
                modelValueTem.value = ['ALL'];
            }
        }
        if (!all) {
            if (modelValueTem.value.length === optionsProp.value.length) {
                modelValueTem.value = ['ALL'];
            }
            const el = {[label]: '全て', [value]: 'ALL'}
            optionsProp.value.unshift(el);
        }
    }
    // if (props.options && modelValueTem.value.length && modelValueTem.value.length === props.options.length) {
    //     multiSelectAllSelected.value = 'YES';
    // } else {
    //     multiSelectAllSelected.value = 'NO';
    // }
})

const listenerKey = (event: any) => {
    if (!props.enableCustomizePanleStyle) {
        return;
    }
    if (event.code === 'ArrowDown') {
        event.preventDefault();
    }
    if (event.altKey && event.code === 'ArrowDown') {
        displayPanle.value = true;
        if (multiSelectIsHide.value) {
            // multiSelectRef.value.$el.click();
        }
    }
    if (event.code === 'Backspace' && !displayPanle.value && modelValueTem.value.length > 0) {
        modelValueTem.value = [];
        // multiSelectAllSelected.value = 'NO';
        multiSelectChange({originalEvent: event, value: []});
    }
 }

 const mouseClick = (event: any) => {
    if (event.pointerType === 'mouse') {
        if (!displayPanle.value && multiSelectRef.value === document.activeElement) {
            multiSelectRef.value.$el.click();
        }
        isMouseClick.value = true;
    }
    emits('click', event);
}

 const multiSelectPanelHide = (event: any) => {
    displayPanle.value = false;
    multiSelectIsHide.value = true;
    isMouseClick.value = false;
    emits('hide', event);
 }

 const multiSelectPanelShow = (event: any) => {
    multiSelectIsHide.value = false;
    emits('show', event);
 }

return (_ctx: any,_cache: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createBlock(_component_MultiSelect, {
    ref_key: "multiSelectRef",
    ref: multiSelectRef,
    modelValue: modelValueTem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValueTem).value = $event)),
    panelClass: __props.enableCustomizePanleStyle && !displayPanle.value && !isMouseClick.value ? 'global-multi-select-panel' : '',
    options: optionsProp.value,
    optionLabel: props.optionLabel,
    optionValue: props.optionValue,
    placeholder: _unref(t)('COMMON.MULTISELECT.PLACEHOLDER'),
    showToggleAll: false,
    onKeydown: listenerKey,
    onHide: multiSelectPanelHide,
    onShow: multiSelectPanelShow,
    class: "p-multiselect-label-container",
    filter: false,
    onChange: multiSelectChange,
    onClick: mouseClick,
    style: {"border":"0px","border-radius":"0px","border-bottom":"1px solid #939090","background":"transparent"}
  }, null, 8, ["modelValue", "panelClass", "options", "optionLabel", "optionValue", "placeholder"]))
}
}

})